export default __webpack_public_path__ + "splash-04.0fa51.svg";